import { useState } from 'react';
import {
  Dialog,
  DialogContent,
} from '@/shared/components/ui/dialog';
import { Button } from '@/shared/components/ui/button';
import type { LanguageCode } from '../../types/entryRules.types';
import { UI_LABELS } from '../../constants/languages.constants';

interface DeleteRuleModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => Promise<void>;
  lang: LanguageCode;
}

export function DeleteRuleModal({ open, onOpenChange, onConfirm, lang }: DeleteRuleModalProps) {
  const [isDeleting, setIsDeleting] = useState(false);
  const labels = UI_LABELS[lang];

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onConfirm();
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[480px] p-6">
        <h2 className="text-lg font-semibold text-gray-900">{labels.deleteConfirmTitle}</h2>
        <p className="text-sm text-gray-500 mt-1">{labels.deleteConfirmText}</p>
        <div className="flex gap-3 mt-6">
          <Button
            variant="outline"
            className="flex-1"
            onClick={() => onOpenChange(false)}
            disabled={isDeleting}
          >
            {labels.cancel}
          </Button>
          <Button
            variant="destructive"
            className="flex-1"
            onClick={handleConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? '...' : labels.deleteConfirmButton}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
